<form
  class="d-flex flex-wrap gap-5"
  [formGroup]="filtersForm"
>
  <base-filter-dropdown
    [items]="statusItems"
    formControlName="status"
    filterName="state"
    optionClass="class"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="qualifications"
    filterName="qualifications.plural"
    formControlName="mainQualification"
    [searchable]="true"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="branches"
    filterName="provider"
    formControlName="pspBranch"
    [searchable]="true"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="departments"
    filterName="department.singular"
    formControlName="department"
    [searchable]="true"
    [displaySubLabel]="true"
    [optionSubLabelSegments]="['customerLocation', 'name']"
  ></base-filter-dropdown>

  <base-datepicker
    [label]=""
    [placeholder]="'inUseFrom' | translate"
    formControlName="fromDate"
    [isFilter]="true"
    [readonly]="true"
    class="full-width"
  ></base-datepicker>

  <base-filter-dropdown
    *ngIf="!isWorkCouncil"
    [items]="openContractItems"
    filterName="contract"
    formControlName="openContract"
  ></base-filter-dropdown>
</form>
<hr *ngIf="activeFilters.length > 0" />
<div class="d-flex align-items-center flex-wrap gap-3 mb-5">
  <div
    *ngFor="let filter of activeFilters"
    class="rounded-pill bg-secondary px-4 py-2 active-filter btn-sm"
  >
    <span class="pe-1 fw-normal">
      {{
        filter.filter === baseCustomerInquiryFilters?.search
          ? ('search.nominative' | translate)
          : (labels[filter.filter] | translate)
      }}:
    </span>
    <span>
      {{ (filter.name | translate) || (filter.value | baseFormatDate) }}
    </span>
    <i
      class="fa-solid fa-xmark ms-2 pointer"
      (click)="removeFilter(filter)"
    ></i>
  </div>
  <span
    *ngIf="activeFilters.length"
    class="pointer"
    (click)="clearFilters()"
  >
    {{ 'filter.reset' | translate }}
  </span>
</div>
